import { useMemo } from "react"
import PropTypes from "prop-types"
import { pick } from "lodash"
import { Dialog, DialogContent } from "@mui/material"
import Form from "components/material/form"

export default function EzeIntegrationDialog({ show, user, onSubmit, onClose }) {
  const form = useMemo(() => {
    return {
      title: "Eze Integration Details",
      submitText: "Save",
      track: {
        type: "eze_integration_user_updated",
        payload: data => pick(data, "ezeUserId"),
      },
      editedItem: user,
      getInitialValues: (args) => {
        const { ezeUserId } = args
        return { ezeUserId }
      },
      onSubmit,
      onClose,
      fields: [{
        id: "ezeUserId",
        label: "Eze user name",
        type: "string",
        validations: {
          isRequired: true,
        },
      }],
    }
  }, [user, onSubmit, onClose])

  return <Dialog className="modules_members_components_eze-integration-dialog" open={show}>
    <DialogContent>
      <Form {...form} />
    </DialogContent>
  </Dialog>
}

EzeIntegrationDialog.propTypes = {
  user: PropTypes.shape({
    ezeUserId: PropTypes.string,
  }),
  show: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
}
